import React from "react";
import { Box, Button, Spacer, useDisclosure } from "@chakra-ui/react";
import { Modal, TextInput, Form } from "components";
import { FormValues } from "../../../../duck";
import { getValidation } from "./duck";

interface IntegrationFormProps {
  serviceName: string;
  onSubmit(formValues: FormValues): Promise<any>;
  defaultValues: FormValues;
  inputName: string;
}

const IntegrationForm: React.FC<IntegrationFormProps> = ({
  serviceName,
  onSubmit,
  defaultValues,
  inputName
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Button
        onClick={onOpen}
        variant="unstyled"
        color="#969AA3"
        fontWeight="semibold"
      >
        {defaultValues[inputName] ? "Change link" : "Link account"}
      </Button>
      {isOpen && (
        <Modal
          isOpen
          onClose={onClose}
          title={`Link ${serviceName} account`}
          size="lg"
        >
          <Form<FormValues>
            onSubmit={formValues => onSubmit(formValues).then(() => onClose())}
            {...getValidation(defaultValues, inputName)}
          >
            {({ reset }) => (
              <>
                <Box py={6}>
                  <TextInput
                    name={inputName}
                    label="Token"
                    placeholder="Token"
                    autoFocus
                  />
                </Box>
                <Form.Controls submitText="Save" mt={4}>
                  {defaultValues[inputName] && (
                    <Button
                      variant="outline"
                      colorScheme="gray"
                      onClick={() => reset({ [inputName]: "" })}
                    >
                      Clear token
                    </Button>
                  )}
                  <Spacer />
                  <Button
                    variant="outline"
                    colorScheme="gray"
                    onClick={onClose}
                  >
                    Cancel
                  </Button>
                </Form.Controls>
              </>
            )}
          </Form>
        </Modal>
      )}
    </>
  );
};

export default IntegrationForm;
